/**
 * AutoCount - Inventory Report Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function ReportsInventory(): JSX.Element {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          {/* Summary Cards */}
          <Grid item xs={12} md={3}>
            <Card>
              <MDBox p={3} textAlign="center">
                <MDTypography variant="h3" color="info">$8,337</MDTypography>
                <MDTypography variant="body2" color="text">Total Inventory Value</MDTypography>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card>
              <MDBox p={3} textAlign="center">
                <MDTypography variant="h3" color="success">377</MDTypography>
                <MDTypography variant="body2" color="text">Total Units</MDTypography>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card>
              <MDBox p={3} textAlign="center">
                <MDTypography variant="h3" color="warning">2</MDTypography>
                <MDTypography variant="body2" color="text">Low Stock Items</MDTypography>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card>
              <MDBox p={3} textAlign="center">
                <MDTypography variant="h3" color="error">0</MDTypography>
                <MDTypography variant="body2" color="text">Out of Stock</MDTypography>
              </MDBox>
            </Card>
          </Grid>

          {/* Report Options */}
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Inventory Reports
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <Card variant="outlined">
                      <MDBox p={3}>
                        <MDTypography variant="h6" mb={1}>Stock Valuation Report</MDTypography>
                        <MDTypography variant="body2" color="text" mb={2}>
                          Complete inventory valuation by category, brand, and location.
                        </MDTypography>
                        <MDButton variant="gradient" color="info" size="small">Generate</MDButton>
                      </MDBox>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Card variant="outlined">
                      <MDBox p={3}>
                        <MDTypography variant="h6" mb={1}>Low Stock Report</MDTypography>
                        <MDTypography variant="body2" color="text" mb={2}>
                          Parts below minimum stock level or reorder point.
                        </MDTypography>
                        <MDButton variant="gradient" color="warning" size="small">Generate</MDButton>
                      </MDBox>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Card variant="outlined">
                      <MDBox p={3}>
                        <MDTypography variant="h6" mb={1}>Movement Report</MDTypography>
                        <MDTypography variant="body2" color="text" mb={2}>
                          Inventory movements, adjustments, and transaction history.
                        </MDTypography>
                        <MDButton variant="gradient" color="secondary" size="small">Generate</MDButton>
                      </MDBox>
                    </Card>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ReportsInventory;
